import { Component, OnInit, Input } from '@angular/core';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-resources-request',
  templateUrl: './resources-request.component.html',
  styleUrls: ['./resources-request.component.scss']
})
export class ResourcesRequestComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoResource: any;
  loading = false;
  data: any = {
    station_id: '',
    deadline: '',
    justification: '',
    name: '',
    resource_type: {},
  }

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<ResourcesRequestComponent>,
    private dialogService: NbDialogService
  ) { }

  ngOnInit() {
    this.checkIfCreateOrEdit()
  }

  async store() {
    this.data.deadline = moment(this.data.deadline).format('YYYY-MM-DD')
    this.data.station_id = this.stationId
    this.loading = true;
    const [error, response] = await this.sasisopaService.createResources(this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Recurso creado con éxito', 'success');
    this.ref.close(true);
  }

  async editResource() {
    this.data.deadline = moment(this.data.deadline).format('YYYY-MM-DD')
    this.loading = true
    const [error, response] = await this.sasisopaService.editResources(this.infoResource.id, this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false
    await this.alert('Recurso editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.deadline = moment(this.infoResource.deadline).toDate()
      this.data.station_id = this.infoResource.station_id
      this.data.name = this.infoResource.name
      this.data.justification = this.infoResource.justification
      this.data.resource_type = this.infoResource.resource_type
    } else {
      return this.data
    }
  }

}
